import React, { useState } from "react";
import {
  AppBar as MuiAppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import IsnLogo from "./IsnLogo";
import { useLogout } from "../hooks/useLogout";

interface TitleBarProps {
  contactUrl: string;
}

const TitleBar: React.FC<TitleBarProps> = ({ contactUrl }) => {
  const logout = useLogout();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // ログアウト処理中フラグ。連打による postLogout の多重POSTを防ぐ
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleContactClick = () => {
    handleMenuClose();
    window.location.href = contactUrl; 
  };

  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      await logout();
    } finally {
      setIsLoggingOut(false);
      handleMenuClose();
    }
  };

  return (
    <MuiAppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <IsnLogo />
        </Box>

        <IconButton
          size="large"
          edge="end"
          color="primary"
          aria-label="menu"
          onClick={handleMenuOpen}
        >
          <MenuIcon />
        </IconButton>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleContactClick}>
            <ListItemText primary="お問い合わせ" />
          </MenuItem>
          <MenuItem onClick={handleLogout} disabled={isLoggingOut}>
            <ListItemText primary="ログアウト" />
          </MenuItem>
        </Menu>
      </Toolbar>
    </MuiAppBar>
  );
};

export default TitleBar;